import { useEffect, useState } from 'react';
import { Source, Layer, Popup, useMap } from 'react-map-gl/mapbox';
import { API_URL } from '../../../config';
import criticalPopulationIcon from '../../../assets/critical-population.png';
import CoordinatesLink from '../Base/CoordinatesLink';
import { authFetch } from '../../../utils';

const CriticalPopulationLayer = ({ visible }) => {
  const [geojsonData, setGeojsonData] = useState(null);
  const [popupInfo, setPopupInfo] = useState(null);
  const { current: map } = useMap();

  useEffect(() => {
    if (!map) return;

    // Verifica si el icono ya está cargado
    if (!map.hasImage('critical-population-icon')) {
      map.loadImage(criticalPopulationIcon, (error, image) => {
        if (error) {
          console.error('Error al cargar el icono:', error);
          return;
        }
        if (!map.hasImage('critical-population-icon')) {
          map.addImage('critical-population-icon', image);
        }
      });
    }
  }, [map]);

  useEffect(() => {
    if (!visible) return;

    authFetch(`${API_URL}emergency-layers/critical-population`)
      .then(res => res.json())
      .then(data => setGeojsonData(data))
      .catch(err => console.error('Error al cargar la población crítica:', err));
  }, [visible]);

  useEffect(() => {
    if (!map || !geojsonData) return;

    const handleClick = e => {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ['critical-population']
      });

      if (features.length > 0) {
        const feature = features[0];
        const coords = feature.geometry.coordinates;
        const props = feature.properties;

        setPopupInfo(null);

        setTimeout(() => {
          setPopupInfo({
            longitude: coords[0],
            latitude: coords[1],
            nombre: props.Nombre,
            telf1: props.Telf1,
            nombre2: props.Nombre2,
            telf2: props.Telf2,
            nombre3: props.Nombre3,
            telf3: props.Telf3,
            nombre4: props.Nombre4,
            telf4: props.Telf4
          });
        }, 0);
      } else {
        setPopupInfo(null);
      }
    };

    map.on('click', handleClick);
    return () => map.off('click', handleClick);
  }, [map, geojsonData]);

  

  if (!visible || !geojsonData) return null;

  return (
    <>
      <Source id="critical-population" type="geojson" data={geojsonData} cluster={false}>
        <Layer
          id="critical-population"
          type="symbol"
            layout={{
                'icon-image': 'critical-population-icon',
                'icon-size': 0.2, // Ajusta el tamaño según lo que necesites
                'icon-offset': [0, -1],
                'icon-anchor': 'top',
                'icon-allow-overlap': true,
                'icon-ignore-placement': true
            }}
        />

      </Source>

      {popupInfo && (
        <Popup
          longitude={popupInfo.longitude}
          latitude={popupInfo.latitude}
          anchor="bottom"
          onClose={() => setPopupInfo(null)}
        >
          <div style={{ lineHeight: '1.4em' }}>
            {popupInfo.nombre && (
              <div><strong>Nombre:</strong> {popupInfo.nombre}</div>
            )}
            {popupInfo.telf1 && (
              <div><strong>Teléfono 1:</strong> {popupInfo.telf1}</div>
            )}
            {popupInfo.nombre2 && (
              <div><strong>Nombre 2:</strong> {popupInfo.nombre2}</div>
            )}
            {popupInfo.telf2 && (
              <div><strong>Teléfono 2:</strong> {popupInfo.telf2}</div>
            )}
            {popupInfo.nombre3 && (
              <div><strong>Nombre 3:</strong> {popupInfo.nombre3}</div>
            )}
            {popupInfo.telf3 && (
              <div><strong>Teléfono 3:</strong> {popupInfo.telf3}</div>
            )}
            {popupInfo.nombre4 && (
              <div><strong>Nombre 4:</strong> {popupInfo.nombre4}</div>
            )}
            {popupInfo.telf4 && (
              <div><strong>Teléfono 4:</strong> {popupInfo.telf4}</div>
            )}
            <CoordinatesLink latitude={popupInfo.latitude} longitude={popupInfo.longitude} />

          </div>
        </Popup>
      )}
    </>
  );
};

export default CriticalPopulationLayer;
